import {InfoWarning} from './InfoWarning';
import {FilledVolunteerDetail} from './FilledVolunteerDetail';

export const AnswersSection = ({visibility, matchingUser, answers}) => {
  if (answers.length <= 0) {
    return null;
  }

  return (
    <>
      {matchingUser && <InfoWarning visibility={visibility} />}
      {answers.map((a) => (
        <FilledVolunteerDetail key={a.label} label={a.label} icon={a.icon} text={a.answer} />
      ))}
    </>
  );
};
